import BrandOne from '../../../../../assets/images/brands/preview-1.png';
import BrandTwo from '../../../../../assets/images/brands/preview-2.png';
import BrandThree from '../../../../../assets/images/brands/preview-3.png';

const brandsArray = [
  {
    ID: 'item-1',
    imagePath: BrandOne,
    brand: 'Apple',
    text: 'Apple is one of the most famous smart watches providing company.',
  },
  {
    ID: 'item-2',
    imagePath: BrandTwo,
    brand: 'Xiaomi',
    text: 'Xiaomi smart watches are produced by MI company.',
  },
  {
    ID: 'item-3',
    imagePath: BrandThree,
    brand: 'FitBit',
    text: 'FitBit smart watches are best for there health and fitness features.',
  },
];

export default brandsArray;
